import { render, staticRenderFns } from "./SupportCenter.vue?vue&type=template&id=a5d6243e&scoped=true"
import script from "./SupportCenter.vue?vue&type=script&lang=js"
export * from "./SupportCenter.vue?vue&type=script&lang=js"
import style0 from "./SupportCenter.vue?vue&type=style&index=0&id=a5d6243e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d6243e",
  null
  
)

export default component.exports